import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { createSelector, select, Store } from '@ngrx/store';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { SelectOptionLoaderI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SelectOptionI } from '../../../../../../shared/modules/configurable-form/components/form-select/models/select-option-i';
import { OrderBuilderState } from '../../../../../reducers';
import { AddedValueFieldConfig } from '../../../models/form-added-value-field-config';
import { getRmsRehydrate } from '../../../selectors';
import { getAddedValuesState } from '../../../selectors/added-value.selectors';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { AddedValueTuple } from '../../../reducers/added-values.reducer';

const addedValueAndRehydrate = createSelector(getAddedValuesState, getRmsRehydrate, (state, rehydate) => {
  return {
    state,
    rehydate,
  };
});

@Injectable()
export class AdddedValuesLoaderService implements SelectOptionLoaderI {
  constructor(private store: Store<OrderBuilderState>) {}

  /**
   * Provides an observable of paymentTerms
   * @return {Observable<SelectOptionI[]>}
   */
  loadOptions(formGroup: UntypedFormGroup, config: AddedValueFieldConfig): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(addedValueAndRehydrate),
      filter(({ state }) => {
        const selectedProduct = formGroup.get(SpecFieldNames.PRODUCT_SELECTION).value;
        return !!state.availableAddedValues[selectedProduct];
      }),
      map(({ state }) => {
        const selectedProduct = formGroup.get(SpecFieldNames.PRODUCT_SELECTION).value;
        const availableAddedValues = state.availableAddedValues[selectedProduct];
        return this.getAddedValuesToShow(availableAddedValues, config.index);
      }),
    );
  }

  /**
   * Returns them as combobox options
   * @param tuples
   * @param index
   */
  private getAddedValuesToShow(tuples: AddedValueTuple[], index: number): SelectOptionI[] {
    if (tuples[index] && tuples[index].addedValues) {
      // options is all vaps available
      return tuples[index].addedValues.map((addedValue) => {
        return {
          id: addedValue.family,
          name: addedValue.desc,
        };
      });
    } else {
      return [];
    }
  }
}
